import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CookieCms } from '../../interfaces/cookie-cms.interface';
import { lmwBaseRoutes } from "../../routing/route-locales/lmw-base-routes";

@Component({
  selector: 'lmw-base-cookies',
  templateUrl: './cookies.component.html'
})
export class CookiesComponent implements OnInit {

  public cookieCmsData: CookieCms;
  public mobileBackButtonText = lmwBaseRoutes.homeLinkText;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.cookieCmsData = this.route.snapshot.data.cmsData;
  }
}
